import { render, staticRenderFns } from "./EditionsHistoryDiffPopup.vue?vue&type=template&id=5776d952&"
import script from "./EditionsHistoryDiffPopup.vue?vue&type=script&lang=js&"
export * from "./EditionsHistoryDiffPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports